import { FaceTecURScanMatchInitializationError, FaceTecURScanMatchSessionStatus } from "../../../core-sdk/FaceTecURScanMatchSDK.js/FaceTecURScanMatchPublicAPI";
import { URScanMatchStatusEnumFriendlyText } from "./URScanMatchStatusEnumFriendlyText";

// This is a Helper Class to log and display Sample App Messages.
// The Main Purpose of this Class is to help developers learn about the UR Scan+Match SDK Response Statuses.
export class DeveloperStatusMessages {
  public static LOG_PREFIX: string = "FaceTec UR Scan+Match Sample App:";
  // Display the message on the screen for the user
  public static displayMessage = (message: string): void => {
    (document.getElementById("status") as HTMLElement).innerHTML = message;
  };

  // Log the message to the console for the developer. Prefix with 'UR Scan+Match Sample App:' so the messages can be filtered
  public static logMessage = (message: string): void => {
    console.log(`${this.LOG_PREFIX} ${message}`);
  };

  // Display and log the message
  public static logAndDisplayMessage = (message: string): void => {
    this.displayMessage(message);
    this.logMessage(message);
  };

  // Log the FaceTec UR Scan+Match Initialization Error
  public static logInitializationErrorResult = (enumValue: FaceTecURScanMatchInitializationError): void => {
    // User message to display
    const displayMessage: string = URScanMatchStatusEnumFriendlyText.descriptionForInitializationError(enumValue);
    // Message to log for developer
    const logMessage: string = `FaceTecURScanMatchInitializationError: ${enumValue} "${displayMessage}"`;

    this.displayMessage(displayMessage);
    this.logMessage(logMessage);
  };

  // Process FaceTecURScanMatchSessionCallback.onComplete status
  public static logSessionStatusOnSessionComplete = (sessionStatus: FaceTecURScanMatchSessionStatus): void => {
    // User message to display
    const displayMessage: string = "See logs for details";
    // Message to log for developer
    const logMessage: string = `FaceTecURScanMatchSessionStatus: ${sessionStatus} - "${URScanMatchStatusEnumFriendlyText.descriptionForSessionStatus(sessionStatus)}"`;

    this.displayMessage(displayMessage);
    this.logMessage(logMessage);
  };
}
